<template>
  <div class="content">
      <el-form :model="schemeForm" ref="schemeForm" :inline="true">
        <el-form-item prop="iccid">
            <el-input
            v-model="schemeForm.name"
            placeholder="方案名称"
            clearable
            style="width: 240px"
            @keyup.enter.native="search"
            />
        </el-form-item>
        <el-form-item prop="searchTime">
          <el-date-picker 
            style="margin-right:30px"
            value-format="yyyy-MM-dd"
            v-model="schemeForm.searchTime"
            @change="search"
            type="daterange"
            range-separator="-"
            start-placeholder="创建开始日期"
            end-placeholder="创建结束日期">
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleCreate" v-if="adminShow">添加</el-button>
      </el-form>
      <div class="table" style="margin-top: 10px">
        <el-table :data="tableData" border v-loading="loading" 
          :default-expand-all="!adminShow"
          row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="userNum" label="代理商个数" align="center" >
            <template slot-scope="scope">
              <el-link type="primary" @click="handelAgentList(scope.row.id)">{{scope.row.userNum}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="方案名称" align="center" ></el-table-column>
          <el-table-column prop="num" label="卡数量" align="center" ></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" ></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="320" > 
            <template slot-scope="scope">
              <el-button v-if="adminShow"  size="mini" type="primary" plain icon="el-icon-view" @click="infoScheme(scope.row.id)" >查看</el-button>
              <el-button v-if="scope.row.type == '1'"  size="mini" type="primary" plain icon="el-icon-view" @click="infoScheme(scope.row.id)" >查看</el-button>
              <el-button  v-if="adminShow"  size="mini" type="primary" plain icon="el-icon-edit" @click="editScheme(scope.row.id)" >编辑</el-button>
              <el-button  v-if="!adminShow"  size="mini" type="primary" plain icon="el-icon-edit" @click="editSubScheme(scope.row.id)" >编辑</el-button>
              <el-button v-if="scope.row.type == '1'"  size="mini" type="primary" plain icon="el-icon-plus" @click="addSubScheme(scope.row.id)" >新建方案</el-button>
            </template>
        </el-table-column>
        </el-table>
      </div>
      <pagination
        v-if="adminShow"
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
      />

      <el-dialog title="代理商列表" :visible.sync="agentOpen" width="1000px" append-to-body>
          <el-table :data="agentList" border >
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column v-if="adminShow" prop="username" label="账号" align="center"></el-table-column>
            <el-table-column prop="companyName" label="代理商" align="center"></el-table-column>
          </el-table>
      </el-dialog>
  </div>
</template>
<script>
import { agentListsData } from "@/api/api.js"; 
import { baseSchemeList , baseSchemeSubList ,schemeAgentList} from "@/api/api.js";
export default {
  name:'schemeProduct',
  data() {
    return {
      loading:false,
      schemeForm:{
        userId:undefined,
        orderStatus:undefined,
        searchTime:[]
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
      agentList:[],
      agentOpen:false
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    initData() {
      let params = {
        model:{
          ...this.addDateRange(this.schemeForm, this.schemeForm.searchTime)
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      baseSchemeList(params).then(res=>{
          this.loading = false
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
      })
    },
    initSubData(){
      let params = {
        ...this.addDateRange(this.schemeForm, this.schemeForm.searchTime)
      };
      this.loading = true;
      baseSchemeSubList(params).then(res=>{
          this.loading = false
          this.tableData = res.data.data;
      })
    },
    // 搜索
    search(){
      if(this.adminShow){
        this.initData()
      }else{
        this.initSubData()
      }
    },
    // 获取初始化代理商列表
    handelAgentList(schemeId){
      schemeAgentList({schemeId}).then(res=>{
        this.agentOpen = true
        this.agentList = res.data.data
      })
    },
    reset(){
      this.resetForm("schemeForm");
      this.initData();
    },
    handleCreate(){
      this.$router.push(`/scheme/operation/add`);
    },
    addSubScheme(id){
      this.$router.push(`/scheme/operation/subAdd/`+id);
    },
    editScheme(id){
      this.$router.push(`/scheme/operation/edit/`+id);
    },
    editSubScheme(id){
      this.$router.push(`/scheme/operation/subEdit/`+id);
    },
    infoScheme(id){
      this.$router.push(`/scheme/operation/view/`+id);
    }
  },
  created() {
    if(this.adminShow){
      this.initData()
    }else{
      this.initSubData()
    }
    
  }
};
</script>
<style scoped lang="less">
  
</style>
